/**
 * Compact USD, e.g. 1500000000 → "$1.5B", 340000000 → "$340M".
 *
 * We strip a trailing ".0" (e.g. "$340.0M" → "$340M") ourselves rather than via
 * `trailingZeroDisplay: 'stripIfInteger'` because that option isn't in this TS
 * lib's `NumberFormatOptions` yet. Doing it here also makes the output
 * deterministic across ICU versions (Node vs the browser), where default compact
 * trailing-zero handling differs. `maximumFractionDigits: 1` guarantees the only
 * possible trailing zero is a single ".0", which we drop when it sits right
 * before the magnitude suffix (B/M/K/T) or the end of the string.
 */
export function formatAum(aum: number): string {
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(aum);
  return formatted.replace(/\.0(?=[A-Za-z]|$)/, '');
}
